module.exports = __webpack_public_path__ + "static/media/slide7.ed188751.png";